import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        homepage: {
          goToConsultants: 'Access trusted consultants',
          hero: {
            seoTitle: 'The network serving consultants',
            message:
              'The only intermediation platform open by recommendation: exclusive access to tech and business consultants sponsored and monitored over time by the CleverLink community.',
            part1_1: 'The network',
            part2_1: 'serves',
            part3_1: 'consultants.',
            part1_2: 'Consultants',
            part2_2: 'serve',
            part3_2: 'the network.',
          },
          whyCleverLink: {
            title: 'Why CleverLink?',
            reasons: {
              network: {
                title: 'A reliable network',
                description:
                  'No CV directories: only trusted people! For over 10 years, we have only proposed consultants we know well enough, all sponsored by at least one network member and for whom we regularly solicit feedback.',
              },
              cleverScore: {
                title: 'The CleverScore',
                description:
                  'Recommendations, client and manager feedback: the CleverScore synthesizes 13 years of relationship history to privilege only those we can recommend with confidence. If the data is insufficient and the trust index is too low, the profile is not proposed, even if part of the network.',
              },
              stability: {
                title: 'Proven stability',
                description:
                  'Thanks to this exclusive and premium operating model, our clients observe a turnover rate much lower than the market average: that of CleverLink network freelancers is, for example, below that of ESN employees...',
              },
            },
          },
          howItWorks: {
            title: 'How does it work?',
            companies: {
              title: 'For companies:',
              step1: 'You contact us with your need.',
              step2:
                'We identify the most suitable profiles according to their skills, experience and CleverScore.',
              step3: 'You are connected with the best trusted consultant(s).',
            },
            consultants: {
              title: 'For consultants:',
              step1: 'A network member sponsors you (no free registration).',
              step2:
                'We collect feedback from people who have actually worked with you.',
              step3:
                'Your CleverScore evolves with each mission and recommendation.',
            },
          },
          stats: {
            title: 'Some numbers',
            consultantsDescription: 'consultants we have collaborated with.',
            profilesDescription: 'recommended and evaluated profiles.',
            yearsDescription: 'of relationship history and field feedback.',
          },
          conviction: {
            title: 'Our conviction',
            description:
              'The best collaborations are not born from volume but from selectivity. CleverLink does not reference profiles: we recommend people we truly know and who are co-opted to us by those we fully trust.',
          },
          additionalInformation: {
            information1: {
              title: 'Are you a company?',
              description:
                'Access a restricted pool of talents, selected, monitored and recommended over time.',
            },
            information2: {
              title: 'Are you a consultant?',
              description:
                'Registration to CleverLink is not open. Only a member can sponsor you.\nThis is precisely what guarantees the quality and trust of the network!',
            },
          },
        },
        login: {
          header1: 'Sign in to',
          header2: 'CleverLink',
          close: 'Close',
          emailPlaceholder: 'Email address',
          passwordPlaceholder: 'Password',
          forgotPassword: 'Forgot password?',
          cta: 'Sign in',
          discoverText:
            'Discovering CleverLink? This platform is only accessible by co-optation.',
          helpText: 'Having trouble?',
          error:
            'Incorrect credentials. You can try again or contact the administrator.',
          invalidEmail: 'Please enter a valid email address.',
        },
        header: {
          loginButton: 'Connect',
          cleverMate: 'CleverMate',
          myNetwork: 'My network',
          connection: 'Connection',
          disconnection: 'Disconnection',
          myProfile: 'My Profile',
        },
        footer: {
          tagline: 'The co-optation platform for talent.',
          contact: 'Contact',
          email: 'contact@cleverlink.org',
          phone: '+33 1 23 45 67 89',
          legalNotices: 'Legal notices',
          termsOfUse: 'Terms of use',
          cookies: 'Cookies',
          privacyPolicy: 'Privacy policy',
          cleverScore: 'CleverScore',
          aiUsage: 'AI Usage',
          copyright: '© {{year}} CleverLink. All rights reserved.',
        },
        contact: {
          heroEyebrow: "Let's talk",
          title: 'Do you have a',
          titleHighlight: 'talent need',
          description:
            'Company or consultant, our team will get back to you promptly. Tell us about your situation and we will contact you.',
          form: {
            title: 'Send us a message',
            requiredHint: 'Fields marked with * are required.',
            firstName: 'First name',
            firstNamePlaceholder: 'John',
            lastName: 'Last name',
            lastNamePlaceholder: 'Doe',
            email: 'Email address',
            emailPlaceholder: 'john.doe@company.com',
            phone: 'Phone',
            phonePlaceholder: '+33 6 00 00 00 00',
            profile: 'You are',
            profilePlaceholder: 'Select your profile',
            profiles: {
              enterprise: 'A company looking for consultants',
              consultant: 'A consultant wishing to join the network',
              referral: 'I would like to refer someone',
              other: 'Other request',
            },
            subject: 'Message subject',
            subjectPlaceholder: 'e.g. Looking for a React/Node.js consultant',
            message: 'Your message',
            messagePlaceholder:
              'Describe your need or request with as much detail as possible...',
            privacyNotice:
              'Your data is processed by CleverLink to respond to your request. In accordance with GDPR, you have the right to access, rectify and delete your data.',
            submit: 'Send message',
            responseTime: 'We usually reply within 24 to 48 business hours.',
            success:
              'Thank you, your message has been received. Our team will get back to you shortly.',
          },
          sidebar: {
            eyebrow: 'Contact',
            title: 'A team available to understand your needs',
            description:
              'Whether you are looking for a consultant, want to join the network, or have a referral request, CleverLink supports you with a tailored response.',
            emailLabel: 'Email',
            phoneLabel: 'Phone',
            note: 'Tell us about your context, expected timeframe, and the type of profile you are looking for so we can respond effectively.',
          },
          cta: {
            title: 'Looking for trusted consultants?',
            description:
              'Access a selective pool of talents, curated and supported for more than 13 years.',
            button: 'Discover CleverLink',
          },
        },
        aiUsage: {
          heroEyebrow: 'Transparency & Ethics',
          title: 'Our use of',
          titleHighlight: 'Artificial Intelligence',
          description:
            "CleverLink uses AI technologies to improve the relevance of its recommendations. Here's how, why, and with what guarantees for your data.",
          engagement: {
            title: 'Our commitment:',
            description:
              'AI at CleverLink is a decision-support tool, never a substitute for human judgment. Each final recommendation is validated by our team. Personal data never leaves our servers.',
          },
          useCases: {
            eyebrow: 'Concrete applications',
            title: 'What is AI used for at CleverLink?',
            subtitle:
              'AI is used at several stages of the matching process to improve the accuracy and relevance of recommendations.',
            matching: {
              tag: 'Matching',
              title: 'Profile / needs matching',
              description:
                'AI analyzes the needs expressed by companies and matches them with available profiles, taking into account skills, experience, and CleverScore.',
            },
            skills: {
              tag: 'Skills',
              title: 'Skill extraction and classification',
              description:
                'From profiles and past experiences, AI identifies and automatically classifies technical and business skills by area of expertise.',
            },
            summary: {
              tag: 'Summary',
              title: 'Profile summaries',
              description:
                'AI generates structured profile summaries to facilitate quick reading by CleverLink teams during a talent search.',
            },
            analysis: {
              tag: 'Analysis',
              title: 'Analysis of collaborative feedback',
              description:
                'Feedback written by clients and managers is analyzed to extract qualitative signals that enrich the history available for CleverScore.',
            },
            relevance: {
              tag: 'Relevance',
              title: 'Results ranking',
              description:
                'CV database search results are sorted by relevance using an algorithm that takes into account skill-need matching and CleverScore.',
            },
            quality: {
              tag: 'Quality',
              title: 'Anomaly detection',
              description:
                'AI mechanisms help detect inconsistencies in data to maintain the quality and integrity of the CleverLink network.',
            },
          },
          providers: {
            eyebrow: 'Our technology partners',
            title: 'The AI technologies we use',
            subtitle:
              'CleverLink distinguishes two categories of processing according to the sensitivity of the data involved.',
            personalDataTitle:
              'Processing involving personal data — exclusively on-premise',
            anonymizedDataTitle:
              'Processing on anonymized or non-personal data',
            artemia: {
              title: 'Artemia · Mia',
              subtitle:
                'French AI · Deployed in our premises · Co-opted by our network',
              description1:
                "For all processing involving personal data, CleverLink exclusively uses Mia, Artemia's AI assistant — a French company from our own co-optation network.",
              description2:
                'Mia runs on a dedicated GPU in our premises, physically disconnected from the internet during processing. No personal data leaves our servers.',
              guaranteesTitle: 'Artemia · Mia Guarantees',
              tags: {
                french: 'French company',
                onPremise: 'On-premise',
                offline: 'Offline',
                gdpr: '100% GDPR',
                coOpted: 'Co-opted',
              },
              features: {
                hosting: 'Physical hosting in our premises',
                offline: 'Disconnected from internet during processing',
                noTransfer: 'Zero data transfer to the outside',
                trained: 'Model trained on our domain',
                french: 'AI developed in France',
                compliant: 'GDPR & AI Act compliance guaranteed',
              },
            },
            huggingFace: {
              title: 'Hugging Face',
              description:
                'Open source NLP models for skill classification and analysis of anonymized texts (without identifiable personal data).',
              badge: '✓ Anonymized data only',
            },
            scaleway: {
              title: 'Scaleway (hosting)',
              description:
                'French sovereign cloud infrastructure for platform hosting. Data stored in France, GDPR compliant.',
              badge: '✓ France hosting',
            },
          },
          principles: {
            eyebrow: 'Our AI ethics',
            title: 'Our principles of responsible use',
            humanDecision: {
              title: 'Humans remain decision-makers',
              description1: 'AI produces suggestions and analyses, but',
              description2: 'no final decision',
              description3:
                '(highlighting a profile, excluding a consultant) is made automatically. A CleverLink team member systematically validates the proposals.',
            },
            localData: {
              title: 'Personal data: 100% local processing',
              description1:
                'All AI processing involving personal data is carried out exclusively by Mia (Artemia), on a GPU in our premises,',
              description2: 'physically disconnected from the internet',
              description3:
                '. No personal data is transmitted to an external service.',
            },
            transparency: {
              title: 'Processing transparency',
              description:
                'Consultants who are members of the network can request information on how their data has been processed. Contact us at',
            },
            nonDiscrimination: {
              title: 'Non-discrimination and AI Act',
              description1:
                'Matching algorithms are regularly audited to detect any bias. CleverLink commits never to use AI in decisions based on criteria protected by law. Our systems are categorized as',
              description2: 'limited risk',
              description3: 'within the meaning of the AI Act.',
            },
            compliance: {
              title: 'GDPR & AI Act compliance',
              description:
                'All our AI processing complies with GDPR and the requirements of the European AI Regulation. The choice of Artemia/Mia guarantees this compliance even for the most sensitive processing, thanks to a fully local and disconnected deployment.',
            },
          },
          faq: {
            eyebrow: 'Frequently asked questions',
            title: 'Your questions about our AI',
            questions: {
              profile: {
                question: 'Is my profile automatically analyzed by AI?',
                answer1:
                  'Partially. AI analyzes the structured data in your profile to improve matching relevance.',
                answer2: 'The decision to highlight you always remains human',
                answer3: ', validated by a CleverLink team member.',
              },
              dataTransfer: {
                question: 'Is my personal data transmitted to external AIs?',
                answer1: 'No.',
                answer2:
                  'For all processing involving personal data, CleverLink exclusively uses Mia (Artemia), a model deployed on our own servers, in our premises, and physically disconnected from the internet. No personal data leaves our infrastructure.',
              },
              opposition: {
                question: 'Can I object to the use of AI on my profile?',
                answer1:
                  'Yes. In accordance with GDPR, you have the right to object to automated processing. Contact us at',
              },
              artemiaChoice: {
                question: 'Why choose Artemia rather than a cloud AI?',
                answer1:
                  'Artemia is a French company from our own co-optation network — this choice is consistent with our DNA. But above all, their Mia solution allows processing personal data',
                answer2: 'without ever exposing them to third-party servers',
                answer3:
                  '. The GPU in our premises, disconnected from the internet, is the only architecture that guarantees total confidentiality.',
              },
              gdprRights: {
                question:
                  'How do I exercise my GDPR rights related to AI processing?',
                answer1:
                  'For any request for access, rectification, erasure or objection, contact us at',
                answer2: 'We respond within a maximum period of',
                answer3: '30 days',
                answer4: '. See also our',
                answer5: 'legal notices',
              },
            },
          },
          cta: {
            title: 'Questions about our practices?',
            description:
              'Our team is available to answer all your questions about the use of AI and the protection of your data.',
            button: 'Contact us →',
          },
        },
        cookieConsent: {
          ariaLabel: 'Cookie management',
          compact: {
            title: 'Your cookie preferences',
            description:
              'We use cookies to improve your experience on CleverLink. Necessary cookies are always active.',
            customize: 'Customize my choices',
          },
          expanded: {
            title: 'Customize your preferences',
            subtitle:
              'Choose which cookies you allow. Necessary cookies cannot be disabled.',
            collapse: 'Collapse',
            learnMore: 'Learn more about our cookie policy →',
          },
          actions: {
            refuseAll: 'Refuse all',
            acceptAll: 'Accept all',
            customize: 'Customize',
            saveCustom: 'Save my choices',
          },
          categories: {
            necessary: {
              label: 'Necessary',
              badge: 'Always active',
              description: 'Session, security, consent storage. Essential.',
            },
            analytics: {
              label: 'Analytics',
              description:
                'Anonymized audience measurement to improve the platform.',
            },
            functional: {
              label: 'Functional',
              description: 'Storing display and navigation preferences.',
            },
          },
        },
        cookiePreferences: {
          heroEyebrow: 'Privacy & Transparency',
          title: 'Your',
          titleHighlight: 'preferences',
          description:
            'We respect your privacy. Choose the cookies you want to activate. Only strictly necessary cookies are essential for the platform to function.',
          activeCategories_one: 'category out of 3 enabled',
          activeCategories_other: 'categories out of 3 enabled',
          modifyAndSave: 'Modify your preferences below, then save.',
          refuseAll: 'Refuse all',
          acceptAll: 'Accept all',
          preferencesSaved: 'Your preferences have been saved',
          clickToSave: 'Click "Save" to apply your choices.',
          saveButton: 'Save my preferences',
          legalInfo: {
            noData: 'No personal data',
            description:
              'is transmitted to third parties via cookies. Analytical processing uses anonymized data. In accordance with ePrivacy regulations and GDPR, your consent is required for non-essential cookies.',
          },
          lastUpdate: 'Last update: March 2025',
          links: {
            legalNotices: 'Legal notices',
            termsOfUse: 'Terms of use',
            contact: 'Contact us',
          },
          educational: {
            title: 'What is a cookie?',
            paragraph1:
              'A cookie is a small text file placed on your device when you visit a website. It allows the site to remember your preferences, your login session, and to analyze your browsing to improve the service.',
            paragraph2:
              'At CleverLink, we distinguish three types of cookies: essential cookies (always active), analytical cookies (optional activation), and functional cookies (optional activation).',
            paragraph3:
              'You can change your preferences at any time from this page, accessible via the "Cookie preferences" link at the bottom of each platform page.',
          },
          categories: {
            necessary: {
              label: 'Strictly necessary cookies',
              description:
                'These cookies are essential for the platform to function. They manage your login session and ensure the security of your exchanges. Without them, certain essential features cannot work.',
              examples: {
                session: 'Login session (maintaining your authentication)',
                csrf: 'CSRF security token (attack protection)',
                consent: 'Consent preferences (remembering your choices)',
              },
              retention: 'Session duration to 24 hours maximum',
            },
            analytics: {
              label: 'Audience measurement cookies',
              description:
                'These cookies allow us to measure the audience of the platform, analyze the pages consulted, and understand how Members use CleverLink. This anonymized data helps us to continuously improve our services.',
              examples: {
                views: 'Page views and navigation paths (anonymized)',
                time: 'Time spent on each section',
                source: 'Visit source (without personal identification)',
              },
              retention: '13 months',
            },
            functional: {
              label: 'Functional cookies',
              description:
                'These cookies improve your experience on CleverLink by remembering your display preferences, language, and other customizations. They are not essential for functioning but make your browsing smoother.',
              examples: {
                language: 'Language and display preferences',
                filters: 'Remembering filters and search parameters',
                customization:
                  'Interface customization according to your usage',
              },
              retention: '6 months',
            },
          },
          card: {
            required: 'Required',
            enabled: 'Enabled',
            disabled: 'Disabled',
            alwaysActive: 'Always active',
            retention: 'Retention:',
            hideDetails: 'Hide details',
            showCookies: 'See cookies used',
            examplesTitle: 'Examples of cookies deposited',
          },
        },
        common: {
          unexpectedError: 'An unexpected error occurred',
          years: 'years',
          months: 'months',
          days: 'days',
          today: 'Today',
          and: 'and',
          back: 'Back',
          seeLess: 'See less',
          seeMore: 'See more',
        },
        consultant: {
          email: 'Email:',
          active: 'Active:',
          available: 'Available:',
          desiredDailyRate: 'Desired Daily Rate:',
          yes: 'Yes',
          no: 'No',
          availability: {
            title: 'Availability & Rate',
            availabilitySubtitle: 'Availability',
            expectedDailyRateSubtitle: 'Expected daily rate',
            expectedDailyRate: '{{expectedDailyRate}} / day',
          },
          notFound: 'The consultant has a null value',
          biographyTitle: 'Bio',
          certificationsTitle: 'Certifications',
          skillsTitle: 'Professional experiences',
          languagesTitle: 'Languages',
          localisation: {
            title: 'Localisation',
            remotePossibility: 'Remote possible',
          },
          profile_hero: {
            backToList: 'Back to the CV database',
            experiences: {
              count: '{{count}} mission(s)',
              since: 'since {{date}}',
            },
            activeAccount: 'Active account',
            inactiveAccount: 'Inactive account',
            contactBtn: 'Get in touch',
            addToFavoriteBtn: 'Add to favorites',
          },
          referral: {
            title: 'Co-optation',
            by: 'Co-opted by',
            date: 'Co-optation date',
          },
          skills: {
            title: 'Skills & Expertise',
            technicalSkills: 'Technical skills',
          },
        },
        cleverScorePage: {
          hero: {
            eyebrow: 'Our relational knowledge indicator',
            titlePrefix: 'The',
            titleHighlight: 'CleverScore',
            subtitle:
              'A unique index that measures the richness and reliability of relational data CleverLink has on each profile — built on 13 years of collaborative history.',
          },
        },
        legalNoticesPage: {
          hero: {
            eyebrow: 'Legal information',
            title: 'Legal notices',
            subtitle:
              'In accordance with the provisions of Law No. 2004-575 of June 21, 2004 for confidence in the digital economy, the following information is brought to the attention of users of the website www.cleverlink.org.',
          },
          footer: {
            lastUpdate: 'Last updated: {{date}}',
          },
        },
      },
    },
    fr: {
      translation: {
        homepage: {
          goToConsultants: 'Accéder à des consultants de confiance',
          hero: {
            seoTitle: 'Le réseau au service des consultants',
            message:
              "La seule plateforme d'intermédiation ouverte sur recommandation : un accès exclusif aux consultants tech et métier parrainés et suivis dans la durée par la communauté CleverLink.",
            part1_1: 'Le réseau',
            part2_1: 'au service',
            part3_1: 'des consultants.',
            part1_2: 'Les consultants',
            part2_2: 'au service',
            part3_2: 'du réseau.',
          },
          whyCleverLink: {
            title: 'Pourquoi CleverLink ?',
            reasons: {
              network: {
                title: 'Un réseau fiable',
                description:
                  "Pas d'annuaires de CV : que des gens de confiance ! Depuis plus de 10 ans, nous ne proposons que des consultants que nous connaissons suffisamment bien, tous parrainés par au moins un membre du réseau et pour lesquels nous sollicitions régulièrement des avis.",
              },
              cleverScore: {
                title: 'Le CleverScore',
                description:
                  "Recommandations, feedbacks clients et managers : le CleverScore synthétise 13 ans d'historique relationnel pour ne privilégier que ceux que nous pouvons recommander les yeux fermés. Si les données sont insuffisantes et que l'indice de confiance est trop faible, le profil n'est pas proposé, même s'il fait partie du réseau.",
              },
              stability: {
                title: 'Une stabilité prouvée',
                description:
                  "Grâce à ce mode de fonctionnement exclusif et premium, nos clients constatent un taux de turn-over très inférieur à la moyenne du marché : celui des freelances du réseau CleverLink est par exemple en dessous de celui des salariés d'ESN...",
              },
            },
          },
          howItWorks: {
            title: 'Comment ça marche ?',
            companies: {
              title: 'Pour les entreprises :',
              step1: 'Vous nous contactez avec votre besoin.',
              step2:
                'Nous identifions les profils les plus adaptés selon leurs compétences, leur expérience et leur CleverScore.',
              step3:
                'Vous êtes mis en relation avec le ou les meilleur(s) consultants de confiance.',
            },
            consultants: {
              title: 'Pour les consultants :',
              step1:
                "Un membre du réseau vous parraine (pas d'inscription libre).",
              step2:
                'Nous collectons des retours auprès de personnes ayant réellement travaillé avec vous.',
              step3:
                'Votre CleverScore évolue avec chaque mission et recommandation.',
            },
          },
          stats: {
            title: 'Quelques chiffres',
            consultantsDescription:
              'consultants avec qui nous avons collaboré.',
            profilesDescription: 'profils recommandés et évalués.',
            yearsDescription: "d'historique relationnel et de retours terrain.",
          },
          conviction: {
            title: 'Notre conviction',
            description:
              'Les meilleures collaborations ne naissent pas du volume mais de la sélectivité. CleverLink ne référence pas des profils : nous recommandons des personnes que nous connaissons vraiment et qui nous sont cooptées par ceux en qui nous avons pleinement confiance.',
          },
          additionalInformation: {
            information1: {
              title: 'Vous êtes une entreprise ?',
              description:
                'Accédez à un vivier restreint de talents, sélectionnés, suivis et recommandés dans la durée.',
            },
            information2: {
              title: 'Vous êtes consultant ?',
              description:
                "L'inscription à CleverLink n'est pas ouverte. Seul un membre peut vous parrainer.\nC'est précisément ce principe qui garantit la qualité et la confiance du réseau !",
            },
          },
        },
        login: {
          header1: 'Connectez-vous sur',
          header2: 'CleverLink',
          close: 'Fermer',
          emailPlaceholder: 'Adresse e-mail',
          passwordPlaceholder: 'Mot de passe',
          forgotPassword: 'Mot de passe oublié ?',
          cta: 'Se connecter',
          discoverText:
            "Vous découvrez Cleverlink ?\nCette plateforme n'est accessible que sur invitation.",
          helpText: 'Vous rencontrez un problème ?',
          error:
            "Identifiants incorrects. Vous pouvez réessayer ou contacter l'administrateur.",
          invalidEmail: 'Veuillez saisir une adresse e-mail valide.',
        },
        header: {
          loginButton: 'Se connecter',
          cleverMate: 'CleverMate',
          myNetwork: 'Mon réseau',
          connection: 'Se connecter',
          disconnection: 'Se déconnecter',
          contactUs: 'Nous contacter',
          myProfile: 'Mon profil',
        },
        footer: {
          tagline: 'La plateforme de cooptation des talents.',
          contact: 'Contact',
          email: 'contact@cleverlink.org',
          phone: '+33 1 23 45 67 89',
          legalNotices: 'Mentions légales',
          termsOfUse: 'CGU',
          cookies: 'Cookies',
          privacyPolicy: 'Politique de protection des données personnelles',
          cleverScore: 'CleverScore',
          aiUsage: 'Utilisation IA',
          copyright: '© {{year}} CleverLink. Tous droits réservés.',
        },
        contact: {
          heroEyebrow: 'Parlons-nous',
          title: 'Vous avez un',
          titleHighlight: 'besoin en talents',
          description:
            'Entreprise ou consultant, notre équipe vous répond dans les meilleurs délais. Décrivez-nous votre situation et nous prendrons contact avec vous.',
          form: {
            title: 'Envoyez-nous un message',
            requiredHint: "Tous les champs marqués d'un * sont obligatoires.",
            firstName: 'Prénom',
            firstNamePlaceholder: 'Jean',
            lastName: 'Nom',
            lastNamePlaceholder: 'Dupont',
            email: 'Adresse e-mail',
            emailPlaceholder: 'jean.dupont@entreprise.fr',
            phone: 'Téléphone',
            phonePlaceholder: '+33 6 00 00 00 00',
            profile: 'Vous êtes',
            profilePlaceholder: 'Sélectionnez votre profil',
            profiles: {
              enterprise: 'Une entreprise à la recherche de consultants',
              consultant: 'Un consultant souhaitant rejoindre le réseau',
              referral: "Je souhaite parrainer quelqu'un",
              other: 'Autre demande',
            },
            subject: 'Objet du message',
            subjectPlaceholder: "Ex : Recherche d'un consultant React/Node.js",
            message: 'Votre message',
            messagePlaceholder:
              'Décrivez votre besoin ou votre demande avec le plus de détails possible...',
            privacyNotice:
              "Vos données sont traitées par CleverLink pour répondre à votre demande. Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression.",
            submit: 'Envoyer le message',
            responseTime:
              'Nous vous répondons généralement sous 24 à 48h ouvrées.',
            success:
              'Merci, votre message a bien été reçu. Notre équipe vous recontactera rapidement.',
          },
          sidebar: {
            eyebrow: 'Contact',
            title: 'Une équipe disponible pour comprendre votre besoin',
            description:
              'Que vous recherchiez un consultant, souhaitiez rejoindre le réseau ou ayez une demande de parrainage, CleverLink vous accompagne avec une réponse adaptée.',
            emailLabel: 'Email',
            phoneLabel: 'Téléphone',
            note: 'Précisez votre contexte, vos délais et le type de profil recherché pour permettre à nos équipes de vous répondre efficacement.',
          },
          cta: {
            title: 'Vous cherchez des consultants de confiance ?',
            description:
              'Accédez à un vivier restreint de talents, sélectionnés et suivis depuis plus de 13 ans.',
            button: 'Découvrir CleverLink',
          },
        },
        aiUsage: {
          heroEyebrow: 'Transparence & Éthique',
          title: 'Notre utilisation de',
          titleHighlight: "l'Intelligence Artificielle",
          description:
            "CleverLink utilise des technologies d'IA pour améliorer la pertinence de ses recommandations. Voici comment, pourquoi, et avec quelles garanties pour vos données.",
          engagement: {
            title: 'Notre engagement :',
            description:
              "L'IA chez CleverLink est un outil d'aide à la décision, jamais un substitut au jugement humain. Chaque recommandation finale est validée par notre équipe. Les données personnelles ne sortent jamais de nos serveurs.",
          },
          useCases: {
            eyebrow: 'Applications concrètes',
            title: "À quoi sert l'IA sur CleverLink ?",
            subtitle:
              "L'IA intervient à plusieurs étapes du processus de mise en relation pour améliorer la précision et la pertinence des recommandations.",
            matching: {
              tag: 'Matching',
              title: 'Correspondance profils / besoins',
              description:
                "L'IA analyse les besoins exprimés par les entreprises et les met en correspondance avec les profils disponibles, en tenant compte des compétences, de l'expérience et du CleverScore.",
            },
            skills: {
              tag: 'Compétences',
              title: 'Extraction et classification des compétences',
              description:
                "À partir des profils et des expériences passées, l'IA identifie et classe automatiquement les compétences techniques et métier par domaine de spécialité.",
            },
            summary: {
              tag: 'Synthèse',
              title: 'Résumés de profil',
              description:
                "L'IA génère des résumés structurés des profils consultants pour faciliter la lecture rapide par les équipes CleverLink lors d'une recherche de talent.",
            },
            analysis: {
              tag: 'Analyse',
              title: 'Analyse des retours collaboratifs',
              description:
                "Les retours rédigés par clients et managers sont analysés pour en extraire les signaux qualitatifs qui enrichissent l'historique disponible pour le CleverScore.",
            },
            relevance: {
              tag: 'Pertinence',
              title: 'Classement des résultats',
              description:
                'Les résultats de recherche dans la CVthèque sont triés par pertinence grâce à un algorithme qui prend en compte la correspondance compétences-besoin et le CleverScore.',
            },
            quality: {
              tag: 'Qualité',
              title: "Détection d'anomalies",
              description:
                "Des mécanismes d'IA contribuent à détecter des incohérences dans les données pour maintenir la qualité et l'intégrité du réseau CleverLink.",
            },
          },
          providers: {
            eyebrow: 'Nos partenaires technologiques',
            title: 'Les technologies IA que nous utilisons',
            subtitle:
              'CleverLink distingue deux catégories de traitements selon la sensibilité des données impliquées.',
            personalDataTitle:
              'Traitements impliquant des données personnelles — exclusivement on-premise',
            anonymizedDataTitle:
              'Traitements sur données anonymisées ou non personnelles',
            artemia: {
              title: 'Artemia · Mia',
              subtitle:
                'IA française · Déployée dans nos locaux · Cooptée par notre réseau',
              description1:
                "Pour l'ensemble des traitements impliquant des données personnelles, CleverLink utilise exclusivement Mia, l'assistant IA d'Artemia — une société française issue de notre propre réseau de cooptation.",
              description2:
                "Mia fonctionne sur un GPU dédié dans nos locaux, physiquement déconnecté d'internet pendant les traitements. Aucune donnée personnelle ne quitte nos serveurs.",
              guaranteesTitle: 'Garanties Artemia · Mia',
              tags: {
                french: 'Société française',
                onPremise: 'On-premise',
                offline: "Déconnecté d'internet",
                gdpr: '100% RGPD',
                coOpted: 'Coopté',
              },
              features: {
                hosting: 'Hébergement physique dans nos locaux',
                offline: "Déconnecté d'internet pendant les traitements",
                noTransfer: "Zéro transfert de données vers l'extérieur",
                trained: 'Modèle entraîné sur notre domaine',
                french: 'IA développée en France',
                compliant: 'Conformité RGPD & AI Act garantie',
              },
            },
            huggingFace: {
              title: 'Hugging Face',
              description:
                "Modèles NLP open source pour la classification de compétences et l'analyse de textes anonymisés (sans données personnelles identifiables).",
              badge: '✓ Données anonymisées uniquement',
            },
            scaleway: {
              title: 'Scaleway (hébergement)',
              description:
                "Infrastructure cloud souveraine française pour l'hébergement de la plateforme. Données stockées en France, conformité RGPD.",
              badge: '✓ Hébergement France',
            },
          },
          principles: {
            eyebrow: 'Notre éthique IA',
            title: "Nos principes d'utilisation responsable",
            humanDecision: {
              title: "L'humain reste décisionnaire",
              description1:
                "L'IA produit des suggestions et des analyses, mais",
              description2: 'aucune décision finale',
              description3:
                "(mise en avant d'un profil, exclusion d'un consultant) n'est prise automatiquement. Un membre de l'équipe CleverLink valide systématiquement les propositions.",
            },
            localData: {
              title: 'Données personnelles : traitement 100% local',
              description1:
                'Tout traitement IA impliquant des données personnelles est réalisé exclusivement par Mia (Artemia), sur un GPU dans nos locaux,',
              description2: "physiquement déconnecté d'internet",
              description3:
                ". Aucune donnée personnelle n'est transmise à un service externe.",
            },
            transparency: {
              title: 'Transparence des traitements',
              description:
                'Les consultants membres du réseau peuvent demander des informations sur la manière dont leurs données ont été traitées. Contactez-nous à',
            },
            nonDiscrimination: {
              title: 'Non-discrimination et IA Act',
              description1:
                "Les algorithmes de matching sont régulièrement audités pour détecter tout biais. CleverLink s'engage à ne jamais utiliser l'IA dans des décisions basées sur des critères protégés par la loi. Nos systèmes sont catégorisés à",
              description2: 'risque limité',
              description3: "au sens de l'AI Act.",
            },
            compliance: {
              title: 'Conformité RGPD & AI Act',
              description:
                "Tous nos traitements IA sont conformes au RGPD et aux exigences du Règlement européen sur l'IA. Le choix d'Artemia/Mia garantit cette conformité même pour les traitements les plus sensibles, grâce à un déploiement entièrement local et déconnecté.",
            },
          },
          faq: {
            eyebrow: 'Questions fréquentes',
            title: 'Vos questions sur notre IA',
            questions: {
              profile: {
                question:
                  'Mon profil est-il analysé automatiquement par une IA ?',
                answer1:
                  "Partiellement. L'IA analyse les données structurées de votre profil pour améliorer la pertinence du matching.",
                answer2:
                  'La décision de vous mettre en avant reste toujours humaine',
                answer3: ", validée par un membre de l'équipe CleverLink.",
              },
              dataTransfer: {
                question:
                  'Mes données personnelles sont-elles transmises à des IA externes ?',
                answer1: 'Non.',
                answer2:
                  "Pour l'ensemble des traitements impliquant des données personnelles, CleverLink utilise exclusivement Mia (Artemia), un modèle déployé sur nos propres serveurs, dans nos locaux, et physiquement déconnecté d'internet. Aucune donnée personnelle ne quitte notre infrastructure.",
              },
              opposition: {
                question:
                  "Puis-je m'opposer à l'utilisation de l'IA sur mon profil ?",
                answer1:
                  "Oui. Conformément au RGPD, vous disposez d'un droit d'opposition au traitement automatisé. Contactez-nous à",
              },
              artemiaChoice: {
                question:
                  "Pourquoi avoir choisi Artemia plutôt qu'une IA cloud ?",
                answer1:
                  'Artemia est une société française issue de notre propre réseau de cooptation — ce choix est cohérent avec notre ADN. Mais surtout, leur solution Mia permet de traiter des données personnelles',
                answer2: 'sans jamais les exposer à des serveurs tiers',
                answer3:
                  ". Le GPU dans nos locaux, déconnecté d'internet, est la seule architecture qui garantit une confidentialité totale.",
              },
              gdprRights: {
                question:
                  'Comment exercer mes droits RGPD liés aux traitements IA ?',
                answer1:
                  "Pour toute demande d'accès, de rectification, d'effacement ou d'opposition, contactez-nous à",
                answer2: 'Nous répondons dans un délai maximal de',
                answer3: '30 jours',
                answer4: '. Voir aussi nos',
                answer5: 'mentions légales',
              },
            },
          },
          cta: {
            title: 'Des questions sur nos pratiques ?',
            description:
              "Notre équipe est disponible pour répondre à toutes vos questions sur l'utilisation de l'IA et la protection de vos données.",
            button: 'Nous contacter →',
          },
        },
        cookieConsent: {
          ariaLabel: 'Gestion des cookies',
          compact: {
            title: 'Vos préférences en matière de cookies',
            description:
              'Nous utilisons des cookies pour améliorer votre expérience sur CleverLink. Les cookies nécessaires sont toujours actifs.',
            customize: 'Personnaliser mes choix',
          },
          expanded: {
            title: 'Personnaliser vos préférences',
            subtitle:
              'Choisissez les cookies que vous autorisez. Les cookies nécessaires ne peuvent pas être désactivés.',
            collapse: 'Réduire',
            learnMore: 'En savoir plus sur notre politique cookies →',
          },
          actions: {
            refuseAll: 'Tout refuser',
            acceptAll: 'Tout accepter',
            customize: 'Personnaliser',
            saveCustom: 'Enregistrer mes choix',
          },
          categories: {
            necessary: {
              label: 'Nécessaires',
              badge: 'Toujours actif',
              description:
                'Session, sécurité, mémorisation du consentement. Indispensables.',
            },
            analytics: {
              label: 'Audience',
              description:
                "Mesure d'audience anonymisée pour améliorer la plateforme.",
            },
            functional: {
              label: 'Fonctionnels',
              description:
                "Mémorisation des préférences d'affichage et de navigation.",
            },
          },
        },
        cookiePreferences: {
          heroEyebrow: 'Vie privée & transparence',
          title: 'Vos',
          titleHighlight: 'préférences',
          description:
            'Nous respectons votre vie privée. Choisissez les cookies que vous souhaitez activer. Seuls les cookies strictement nécessaires sont indispensables au fonctionnement de la plateforme.',
          activeCategories_one: 'catégorie sur 3 activée',
          activeCategories_other: 'catégories sur 3 activées',
          modifyAndSave:
            'Modifiez vos préférences ci-dessous, puis enregistrez.',
          refuseAll: 'Tout refuser',
          acceptAll: 'Tout accepter',
          preferencesSaved: 'Vos préférences ont été enregistrées',
          clickToSave: 'Cliquez sur « Enregistrer » pour appliquer vos choix.',
          saveButton: 'Enregistrer mes préférences',
          legalInfo: {
            noData: 'Aucune donnée personnelle',
            description:
              "n'est transmise à des tiers via les cookies. Les traitements analytiques utilisent des données anonymisées. Conformément à la réglementation ePrivacy et au RGPD, votre consentement est requis pour les cookies non essentiels.",
          },
          lastUpdate: 'Dernière mise à jour : mars 2025',
          links: {
            legalNotices: 'Mentions légales',
            termsOfUse: 'CGU',
            contact: 'Nous contacter',
          },
          educational: {
            title: "Qu'est-ce qu'un cookie ?",
            paragraph1:
              "Un cookie est un petit fichier texte déposé sur votre appareil lors de votre visite sur un site web. Il permet au site de mémoriser vos préférences, votre session de connexion et d'analyser votre navigation pour améliorer le service.",
            paragraph2:
              'Sur CleverLink, nous distinguons trois types de cookies : les cookies indispensables (toujours actifs), les cookies analytiques (activation facultative) et les cookies fonctionnels (activation facultative).',
            paragraph3:
              'Vous pouvez modifier vos préférences à tout moment depuis cette page, accessible via le lien « Préférences cookies » en bas de chaque page de la plateforme.',
          },
          categories: {
            necessary: {
              label: 'Cookies strictement nécessaires',
              description:
                'Ces cookies sont indispensables au fonctionnement de la plateforme. Ils permettent la gestion de votre session de connexion et assurent la sécurité de vos échanges. Sans eux, certaines fonctionnalités essentielles ne peuvent pas fonctionner.',
              examples: {
                session:
                  'Session de connexion (maintien de votre authentification)',
                csrf: 'Jeton de sécurité CSRF (protection contre les attaques)',
                consent:
                  'Préférences de consentement (mémorisation de vos choix)',
              },
              retention: 'Durée de session à 24 heures maximum',
            },
            analytics: {
              label: "Cookies de mesure d'audience",
              description:
                "Ces cookies nous permettent de mesurer l'audience de la plateforme, d'analyser les pages consultées et de comprendre comment les Membres utilisent CleverLink. Ces données, anonymisées, nous aident à améliorer continuellement nos services.",
              examples: {
                views: 'Pages vues et parcours de navigation (anonymisés)',
                time: 'Temps passé sur chaque section',
                source:
                  'Provenance des visites (sans identification personnelle)',
              },
              retention: '13 mois',
            },
            functional: {
              label: 'Cookies fonctionnels',
              description:
                "Ces cookies améliorent votre expérience sur CleverLink en mémorisant vos préférences d'affichage, votre langue et d'autres personnalisations. Ils ne sont pas indispensables au fonctionnement mais rendent votre navigation plus fluide.",
              examples: {
                language: "Préférences de langue et d'affichage",
                filters: 'Mémorisation des filtres et paramètres de recherche',
                customization:
                  "Personnalisation de l'interface selon vos usages",
              },
              retention: '6 mois',
            },
          },
          card: {
            required: 'Requis',
            enabled: 'Activé',
            disabled: 'Désactivé',
            alwaysActive: 'Toujours actif',
            retention: 'Conservation :',
            hideDetails: 'Masquer les détails',
            showCookies: 'Voir les cookies utilisés',
            examplesTitle: 'Exemples de cookies déposés',
          },
        },
        common: {
          unexpectedError: "Une erreur inattendue s'est produite",
          notCommunicated: 'N/C',
          years: 'ans',
          months: 'mois',
          days: 'jours',
          today: "Aujourd'hui",
          and: 'et',
          back: 'Retour',
          seeLess: 'Voir moins',
          seeMore: 'Voir plus',
        },
        consultant: {
          email: 'Email :',
          active: 'Actif :',
          available: 'Disponible :',
          desiredDailyRate: 'Tarif journalier souhaité :',
          yes: 'Oui',
          no: 'Non',
          availability: {
            title: 'Disponibilité & Tarif',
            availabilitySubtitle: 'Disponibilité',
            expectedDailyRateSubtitle: 'TJM souhaité',
            expectedDailyRate: '{{expectedDailyRate}} / jour',
          },
          notFound: 'Le consultant a la valeur null',
          biographyTitle: 'Bio',
          certificationsTitle: 'Certifications',
          skillsTitle: 'Expériences professionnelles',
          languagesTitle: 'Langues',
          localisation: {
            title: 'Localisation',
            remotePossibility: 'Télétravail possible',
          },
          profile_hero: {
            backToList: 'Retour à la CVthèque',
            experiences: {
              count: '{{count}} mission(s)',
              since: 'depuis {{date}}',
            },
            activeAccount: 'Compte actif',
            inactiveAccount: 'Compte inactif',
            contactBtn: 'Rentrer en contact',
            addToFavoriteBtn: 'Ajouter aux favoris',
          },
          referral: {
            title: 'Cooptation',
            by: 'Parrainé par',
            date: 'Date de cooptation',
          },
          skills: {
            title: 'Compétences & Expertise',
            technicalSkills: 'Compétences techniques',
          },
        },
        cleverScorePage: {
          hero: {
            eyebrow: 'Notre indicateur de connaissance relationnelle',
            titlePrefix: 'Le',
            titleHighlight: 'CleverScore',
            subtitle:
              "Un indice unique qui mesure la richesse et la fiabilité des données relationnelles dont dispose CleverLink sur chaque profil — construit sur 13 ans d'historique collaboratif.",
          },
        },
        legalNoticesPage: {
          hero: {
            eyebrow: 'Informations légales',
            title: 'Mentions légales',
            subtitle:
              "Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique, les informations suivantes sont portées à la connaissance des utilisateurs du site www.cleverlink.org.",
          },
          footer: {
            lastUpdate: 'Dernière mise à jour : {{date}}',
          },
        },
      },
    },
  },
  lng: 'fr',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
